import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getComponents, getValue } from "../../helpers";
import { updateModalContent } from "../../../../../../stateManager/store/formCreation_v2/actions";
import { Dropdown } from "../layout-components/helpers/constants";
import { ReactComponent as ExpandIcon } from "../../../../../../assets/svg/solobuilder/expandlight.svg";
import { ReactComponent as ExpandDarkIcon } from "../../../../../../assets/svg/solobuilder/expanddark.svg";
import { ReactComponent as Down } from "../../../../../../assets/svg/solobuilder/dropdown-down.svg";
import { ReactComponent as Up } from "../../../../../../assets/svg/solobuilder/dropdown-up.svg";
import { ReactComponent as Delete } from "../../../../../../assets/svg/solobuilder/expansion-delete.svg";
import DropdownIcon from "../../../../../../assets/svg/solobuilder/dropdown.svg"
import FontStyles from "../fontStyles/FontStyles";
import FontStylesPopper from "../fontStyles/FontStylesPopper";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { onsetClrPicContext } from "../../../../../../stateManager/store/common/action";
import { Disclosure, Transition } from "@headlessui/react";
import { AppState } from "../../../../../../stateManager/store";


type IMarginProps = {
    label?: string;
    editMode?: boolean;
    isCheckedIn?: boolean;
    defaultValue?: any;
    onChange: Function;
    onToggleExpand?: any;
    isExpandMargin?: boolean;
    onMarginChange?: any;
}

const Margin = (props: IMarginProps) => {
    const { isCheckedIn, defaultValue, label, editMode, onChange, isExpandMargin, onToggleExpand, onMarginChange } = props;
    const [value, setValue] = useDebouncedAction(defaultValue?.margin?.replace("px", ""), 1000 || "");

    return (
        <>
            <div className="panel-div">
                <label
                    htmlFor="margin"
                    className="panel-label"
                    style={{ width: editMode ? "84px" : "94px" }}
                >
                    {label}
                </label>
                <input
                    style={{ cursor: !isCheckedIn ? "not-allowed" : "auto", width: "140px" }}
                    disabled={!isCheckedIn}
                    type="number"
                    id="margin"
                    defaultValue={value}
                    className="panel-input"
                    placeholder="0"
                    onChange={e => {
                        const newValue = e.target.value || 0;
                        setValue(newValue, () => onChange(newValue));
                    }}
                />
                <div onClick={onToggleExpand}>
                    {isExpandMargin ? (
                        <ExpandDarkIcon
                            style={{ width: 15, height: 15, marginLeft: "2px" }}
                            className=" items-center cursor-pointer"
                        />
                    ) : (
                        <ExpandIcon
                            style={{ width: 15, height: 15, marginLeft: "2px" }}
                            className=" items-center cursor-pointer"
                        />
                    )}
                </div>
            </div>

            {isExpandMargin && (
                <div className="flex justify-end" style={{ marginTop: "10px", gap: "4px" }} >
                    <MarginTop
                        onChange={(value: number) => onMarginChange(value,"top")}
                        isCheckedIn={props.isCheckedIn}
                        defaultValue={defaultValue?.["margin-top"]}
                    />
                    <MarginRight
                        onChange={(value: number) => onMarginChange(value,"right")}
                        isCheckedIn={props.isCheckedIn}
                        defaultValue={defaultValue?.["margin-right"]}
                    />
                    <MarginBottom
                        onChange={(value: number) => onMarginChange(value,"bottom")}
                        isCheckedIn={props.isCheckedIn}
                        defaultValue={defaultValue?.["margin-bottom"]}
                    />
                    <MarginLeft
                        onChange={(value: number) => onMarginChange(value,"left")}
                        isCheckedIn={props.isCheckedIn}
                        defaultValue={defaultValue?.["margin-left"]}
                    />
                </div>
            )}
        </>
    )
};

const MarginTop = (props: IMarginProps) => {
    const { defaultValue, onChange } = props;
    const [value, setValue] = useDebouncedAction(defaultValue?.replace("px", ""), 500 || "");

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                height: "28px",
                width: "34px",
                border: "2px solid #7D84924D",
                borderRadius: "2px",
                borderTopRightRadius: "3.5px",
                borderTopLeftRadius: "3.5px",
                borderTop: "none",
                marginLeft: "7px"
            }}
        >
            <input
                type="number"
                id="margintop"
                style={{
                    position: "absolute",
                    height: "28px",
                    width: "34px",
                    borderWidth: "2.3px",
                    borderTopColor: (value && value != "0") ? "rgba(241, 114, 46, 1)" : "#052f35 ",
                    borderStyle: "solid",
                    borderLeft: "none",
                    borderRadius: "4px",
                    borderRight: "none",
                    borderBottom: "none",
                    background: "none",
                    outline: "none",
                }}
                className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
                placeholder="0"
                value={value}
                onChange={e => {
                    const newValue = e.target.value || 0;
                    setValue(newValue, () => onChange(newValue));
                }
                }
            />
        </div>
    )
}

const MarginRight = (props: IMarginProps) => {
    const { defaultValue, onChange } = props;
    const [value, setValue] = useDebouncedAction(defaultValue?.replace("px", ""), 500 || "");

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                height: "28px",
                width: "34px",
                border: "2px solid #7D84924D",
                borderRadius: "2px",
                borderTopRightRadius: "3.5px",
                borderBottomRightRadius: "3.5px",
                borderRight: "none",
                marginLeft: "7px"
            }}
        >
            <input
                type="number"
                id="marginright"
                style={{
                    position: "absolute",
                    height: "28px",
                    width: "34px",
                    borderWidth: "2.3px",
                    borderStyle: "solid",
                    borderRadius: "4px",
                    borderRightColor: (value && value != "0") ? "rgba(241, 114, 46, 1)" : "#052f35 ",
                    borderBottom: "none",
                    borderLeftWidth: "2.3px",
                    borderLeftColor: "transparent",
                    background: "none",
                    borderTop: "none",
                    outline: "none",
                }}
                className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
                placeholder="0"
                value={value}
                onChange={e => {
                    const newValue = e.target.value || 0;
                    setValue(newValue, () => onChange(newValue));
                }
                }
            />
        </div>
    )
}

const MarginBottom = (props: IMarginProps) => {
    const { defaultValue, onChange } = props;
    const [value, setValue] = useDebouncedAction(defaultValue?.replace("px", ""), 500 || "");

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                height: "28px",
                width: "34px",
                border: "2px solid #7D84924D",
                borderRadius: "2px",
                borderBottomRightRadius: "3.5px",
                borderBottomLeftRadius: "3.5px",
                borderBottom: "none",
                marginLeft: "7px"
            }}
        >
            <input
                type="number"
                id="marginbottom"
                style={{
                    position: "absolute", left: "-1.5px",
                    height: "28px",
                    width: "34px",
                    borderWidth: "2.3px",
                    borderStyle: "solid",
                    borderRadius: "4px",
                    borderBottomColor: (value && value != "0") ? "rgba(241, 114, 46, 1)" : "#052f35 ",
                    borderRight: "none",
                    borderTopWidth: "2.3px",
                    borderTopColor: "transparent",
                    borderLeft: "none",
                    background: "none",
                    outline: "none",
                }}
                className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
                placeholder="0"
                value={value}
                onChange={e => {
                    const newValue = e.target.value || 0;
                    setValue(newValue, () => onChange(newValue));
                }
                }
            />
        </div>
    )
}

const MarginLeft = (props: IMarginProps) => {
    const { defaultValue, onChange } = props;
    const [value, setValue] = useDebouncedAction(defaultValue?.replace("px", ""), 500 || "");

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                height: "28px",
                width: "34px",
                border: "2px solid #7D84924D",
                borderRadius: "2px",
                borderTopLeftRadius: "3.5px",
                borderBottomLeftRadius: "3.5px",
                borderLeft: "none",
                marginLeft: "7px"
            }}
        >
            <input
                type="number"
                id="marginleft"
                style={{
                    position: "absolute",
                    height: "28px",
                    width: "34px",
                    borderWidth: "2.3px",
                    borderStyle: "solid",
                    borderRadius: "4px",
                    borderLeftColor: (value && value != "0") ? "rgba(241, 114, 46, 1)" : "#052f35 ",
                    borderBottom: "none",
                    borderRightWidth: "2.3px",
                    borderRightColor: "transparent",
                    background: "none",
                    borderTop: "none",
                    outline: "none",
                }}
                className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
                placeholder="0"
                value={value}
                onChange={e => {
                    const newValue = e.target.value || 0;
                    setValue(newValue, () => onChange(newValue));
                }
                }
            />
        </div>
    )
}

export const ModalExpansionPanel = (props: any) => {
    const { tabAddMode, ErrMessage, onModalChange, modalConfigs } = props
    const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson);
    const [icons, setIcons] = useState<string>();
    const [imageHeightMode, setImageHeightMode] = useState({ label: '%', value: '%' });
    const [imageWidthMode, setImageWidthMode] = useState({ label: '%', value: '%' });
    const [fontStylesVisibility, setFontStylesVisibility] = useState(false);
    const [editFontStylesVisibility, setEditFontStylesVisibility] = useState(false);
    const { components } = getComponents();
    const component = components[selectedElementId] || {};
    const body = getValue(component, `properties.body`.split("."), deviceType) || [];
    const [expandedMargins, setExpandedMargins] = useState<Record<string, boolean>>({});
    const [isExpandedMargin, setIsExpandedMargin] = useState<boolean>(false);
    const [editingIndex, setEditingIndex] = useState<number>(0);
    const dispatch = useDispatch();

    type IDropDownProps = {
        selectedOption: string;
        onSelect: Function;
        id?: string;
        i?: number;
        type?: string;
        value?: string;
    }

    const handleHeightSelect = (option: any, id: any, i: any, value: any) => {
        setImageHeightMode(option);
        if (value)
            onModalEdit(i, id, "styles", "height", `${value}${option.value}`);
        else
            onModalChange("styles", "height", option.value);
    };

    const handleWidthSelect = (option: any, id: any, i: any, value: any) => {
        setImageWidthMode(option);
        if (value)
            onModalEdit(i, id, "styles", "width", `${value}${option.value}`);
        else
            onModalChange("styles", "width", option.value);
    };

    const ImageDropDown = (props: IDropDownProps) => {
        const { selectedOption, onSelect } = props;
        const options = [
            { label: 'px', value: 'px' },
            { label: '%', value: '%' },
            { label: 'Auto', value: 'auto' },
            { label: 'Min', value: 'min-content' },
            { label: 'Max', value: 'max-content' },
        ];
        const [isOpen, setIsOpen] = useState(false);

        useEffect(() => {
            const handleClickOutside = (event: any) => {
                const dropdownElement = document.getElementById('custom-select-dropdown');

                if (dropdownElement) {
                    if (!dropdownElement.contains(event.target)) {
                        setIsOpen(false);
                    }
                }
            };

            document.addEventListener("mousedown", handleClickOutside);

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, []);

        const toggleDropdown = () => setIsOpen(!isOpen);

        const handleSelect = (option: any) => {
            setIsOpen(false);
            if (props?.id && (option.value != "px" && option.value != "%")) {
                onModalEdit(props?.i || 0, props?.id || "", "styles", props?.type || "", option.value);
            }
            else if (props?.value) {
                onSelect(option, props?.id, props?.i, props?.value);
            } else {
                onSelect(option);
            }
        };

        return (
            <div className="relative">
                <button
                    onClick={toggleDropdown}
                    style={{
                        width: (selectedOption === "px" || selectedOption === "%") ? "32px" : "158px",
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        backgroundColor: 'white',
                        paddingRight: '10px',
                        backgroundImage: `url(${DropdownIcon})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right center',
                        backgroundSize: '9px',
                        cursor: "pointer",
                        textAlign: "left"
                    }}>
                    {selectedOption}
                </button>
                {isOpen && (
                    <div
                        id="custom-select-dropdown"
                        style={{
                            position: 'absolute',
                            top: "24px",
                            left: "-5px",
                            width: (selectedOption === "px" || selectedOption === "%") ? "48px" : "170px",
                            maxHeight: "94px",
                            zIndex: 40,
                            backgroundColor: 'white',
                            border: "1px solid rgba(125, 132, 146, 0.294)",
                            borderRadius: "4px",
                            boxShadow: "rgba(125, 132, 146, 0.11) 0px 5px 8px",
                            overflowY: "auto",
                            paddingBottom: "10px"
                        }}
                    >
                        {options.map((option, idx) => (
                            <div
                                key={idx}
                                onClick={() => handleSelect(option)}
                                style={{
                                    margin: "10px 10px 0px 10px",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    color: option.label === selectedOption ? "#e27841" : "#505f7b",
                                    cursor: "pointer"
                                }}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>)
                }
            </div>)
    }

    const data = {
        contentType: [
            {
                label: "Text",
                value: "text"
            },
            {
                label: "Icon",
                value: "icon"
            },
            {
                label: 'Input',
                value: "input"
            },
            {
                label: "Image",
                value: "image"
            }
        ],
        textAlign: [
            {
                label: "Left",
                value: "left"
            },
            {
                label: "Center",
                value: "center"
            },
            {
                label: 'Right',
                value: "right"
            }
        ],
        icons: [
            {
                label: "Success",
                value: "success"
            },
            {
                label: "Error",
                value: "error"
            },
            {
                label: 'Spinner',
                value: "spinner"
            }
        ]
    }

    const defaultFontStyle = {
        placeholder: "",
        where: "modalContent",
        type: "",
        label: "Font Settings",
        category: "",
        value: {
            size: 14,
            weight: 500,
            color: "#666980",
            alignment: "",
            case: "",
            family: "Inherit",
            decoration: "",
            lineHeight: "24px",
            letterSpacing: 0
        }
    }

    const [fontStylesContext, setFontStylesContext] = useState<any>(defaultFontStyle);
    const [editFontStylesContext, setEditFontStylesContext] = useState<Record<string, any>>(defaultFontStyle);

    const editContent = (content: any, idx: number) => {
        dispatch(
            updateModalContent({
                type: "EDIT",
                content,
                idx
            })
        );
    };

    const handleChange = (idx: number, i: number, values: any) => {
        let selContent: any = body.find((item: any) => item.id === idx);
        if (selContent) {
            values["font-size"] = values.size + "px";
            values["font-weight"] = `${values.weight}`;
            values["text-align"] = `${values.alignment}`;
            values["text-decoration"] = `${values.decoration}`;
            values["text-transform"] = `${values.case}`;
            values["letter-spacing"] = values.letterSpacing + "px";
            selContent = {
                ...selContent,
                [selContent.type]: {
                    ...selContent[selContent.type],
                    styles: {
                        ...selContent.styles,
                        ...values
                    }
                }
            };
            editContent(selContent, i);
        }
    };

    const onModalEdit = (
        index: number,
        id: string,
        type: 'type' | 'config' | 'styles',
        name: string,
        value: any
    ) => {
        let selContent: any = body.find((i: any) => i.id === id);
        switch (type) {
            case 'config':
                selContent = {
                    ...selContent,
                    [selContent.type]: {
                        ...selContent[selContent.type],
                        [name]: value
                    }
                }
                break;

            case 'styles':
                selContent = {
                    ...selContent,
                    [selContent.type]: {
                        ...selContent[selContent.type],
                        styles: {
                            ...selContent[selContent.type].styles,
                            [name]: value
                        }
                    }
                };
                break;

            case 'type':
                if (value === "Text") {
                    selContent = {
                        ...selContent,
                        [name]: value,
                        [value]: {
                            ...selContent[value],
                            content: selContent[value]?.content || ""
                        }
                    }
                } else if (value === "Icon") {
                    selContent = {
                        ...selContent,
                        [name]: value,
                        [value]: {
                            variant: selContent[value]?.variant || "success"
                        }
                    }
                    setIcons(selContent[value] ? selContent[value].variant.charAt(0).toUpperCase() + selContent[value].variant.slice(1) : "Success");
                } else if (value === "Input") {
                    selContent = {
                        ...selContent,
                        [name]: value,
                        [value]: {
                            ...selContent[value],
                            name: selContent[value]?.name || ""
                        }
                    }
                } else if (value === "Image") {
                    selContent = {
                        ...selContent,
                        [name]: value,
                        [value]: {
                            ...selContent[value],
                            url: selContent[value]?.url || ""
                        }
                    }
                }
                break;

            default:
                return;
        }
        editContent(selContent, index);
    };

    const deleteContent = (idx: number) => {
        dispatch(
            updateModalContent({
                type: "DELETE",
                idx
            })
        );
    };

    return (
        <>
            {tabAddMode &&
                <div className="w-full">
                    <div className="w-full bg-transparent">
                        <div className="panel-div flex items-center justify-between">
                            <label className="panel-label">
                                Content type
                            </label>
                            <Dropdown
                                cursorStyle="pointer"
                                options={data.contentType
                                    ? data.contentType.map((el) => ({
                                        name: el.label
                                    }))
                                    : []}
                                selected={{ name: modalConfigs.type }}
                                placeholder="Select content type"
                                onChange={(option) => {
                                    if (data.contentType) {
                                        const item = data.contentType.find(item => item.label === option.name)
                                        if (item) {
                                            onModalChange("type", "type", item.label);
                                            setIcons(undefined);
                                            setIsExpandedMargin(false);
                                            setImageHeightMode({ label: '%', value: '%' });
                                            setImageWidthMode({ label: '%', value: '%' });
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                    {modalConfigs.type === "Text" &&
                        <>
                            <div className="panel-div">
                                <label className="panel-label">Content</label>
                                <input placeholder="Enter content" type="string" className="panel-input"
                                    onClick={() => { onModalChange("styles", "font", defaultFontStyle.value); setFontStylesContext(defaultFontStyle); }}
                                    onChange={(e: any) => { onModalChange("config", "content", e.target.value) }}></input>
                            </div>
                            <FontStyles
                                key={selectedElementId}
                                label="Font settings"
                                value={fontStylesContext}
                                placeholder="Customize text apperance"
                                open={() => {
                                    dispatch(onsetClrPicContext({
                                        value: "#666980",
                                        where: 'background',
                                        visibility: false,
                                        type: "addExpansion_newSetup"
                                    }))
                                    setEditFontStylesVisibility(false);
                                    setFontStylesVisibility(true);
                                }}
                            >
                            </FontStyles>
                            {fontStylesVisibility ?
                                <FontStylesPopper
                                    component={component}
                                    isCheckedIn={true}
                                    close={() => {
                                        setFontStylesVisibility(false);
                                    }}
                                    onChange={(where: string, values: any) => onModalChange("styles", "font", values)}
                                    fontStylesContext={fontStylesContext}
                                    setFontStylesContext={setFontStylesContext}
                                    open={() => {
                                        dispatch(onsetClrPicContext({
                                            value: "#666980",
                                            where: 'background',
                                            visibility: true,
                                            type: "addExpansion_newSetup"
                                        }))
                                    }}
                                >
                                </FontStylesPopper> : null
                            }
                            <Margin
                                onChange={(value: number) => onModalChange("styles", "margin", `${value}px`)}
                                label="Margin"
                                key="text"
                                onMarginChange={(value:number,postion:string)=>onModalChange("styles", `margin-${postion}`, `${value}px`)}
                                defaultValue={modalConfigs?.Text?.styles}
                                onToggleExpand={() => setIsExpandedMargin(!isExpandedMargin)}
                                isExpandMargin={isExpandedMargin}
                                isCheckedIn={props.isCheckedIn}
                            />
                        </>
                    }
                    {modalConfigs.type === "Icon" &&
                        <>
                            <div className="panel-div">
                                <label className="panel-label">Icon variant</label>
                                <Dropdown
                                    cursorStyle="pointer"
                                    options={data.icons
                                        ? data.icons.map((el) => ({
                                            name: el.label
                                        }))
                                        : []}
                                    selected={{ name: icons }}
                                    placeholder="Select icon variant"
                                    onChange={(option) => {
                                        if (data.icons) {
                                            const item = data.icons.find(item => item.label === option.name);
                                            if (item) {
                                                setIcons(item.label);
                                                onModalChange("config", "variant", item.value);
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <Margin
                                onChange={(value: number) => onModalChange("styles", "margin", `${value}px`)}
                                label="Margin"
                                key="icon"
                                onMarginChange={(value:number,postion:string)=>onModalChange("styles", `margin-${postion}`, `${value}px`)}
                                defaultValue={modalConfigs?.Icon?.styles}
                                onToggleExpand={() => setIsExpandedMargin(!isExpandedMargin)}
                                isExpandMargin={isExpandedMargin}
                                isCheckedIn={props.isCheckedIn}
                            />
                        </>
                    }
                    {modalConfigs.type === "Input" &&
                        <>
                            <div className="panel-div">
                                <label className="panel-label">Name</label>
                                <input placeholder="Enter name" type="string" className="panel-input"
                                    onChange={(e: any) => onModalChange("config", "name", e.target.value)}></input>
                            </div>
                            <div className="panel-div">
                                <label className="panel-label">Label</label>
                                <input placeholder="Enter label" type="string" className="panel-input"
                                    onChange={(e: any) => onModalChange("config", "label", e.target.value)}></input>
                            </div>
                            <div className="panel-div">
                                <label className="panel-label">Placeholder</label>
                                <input placeholder="Enter placeholder text" type="string" className="panel-input"
                                    onChange={(e: any) => onModalChange("config", "placeholder", e.target.value)}></input>
                            </div>
                            <Margin
                                onChange={(value: number) => onModalChange("styles", "margin", `${value}px`)}
                                label="Margin"
                                key="input"
                                onMarginChange={(value:number,postion:string)=>onModalChange("styles", `margin-${postion}`, `${value}px`)}
                                defaultValue={modalConfigs?.Input?.styles}
                                onToggleExpand={() => setIsExpandedMargin(!isExpandedMargin)}
                                isExpandMargin={isExpandedMargin}
                                isCheckedIn={props.isCheckedIn}
                            />
                        </>
                    }
                    {modalConfigs.type === "Image" &&
                        <>
                            <div className="panel-div">
                                <label className="panel-label">Image url</label>
                                <input placeholder="Paste image url" type="string" className="panel-input"
                                    onChange={(e: any) => onModalChange("config", "url", e.target.value)}></input>
                            </div>
                            <div className="panel-div">
                                <label className="panel-label">Label</label>
                                <input placeholder="Enter label" type="string" className="panel-input"
                                    onChange={(e: any) => onModalChange("config", "label", e.target.value)}></input>
                            </div>
                            <div className="panel-div">
                                <label className="panel-label">Placeholder</label>
                                <input placeholder="Enter placeholder text" type="string" className="panel-input"
                                    onChange={(e: any) => onModalChange("config", "placeholder", e.target.value)}></input>
                            </div>
                            <div className="panel-div">
                                <label className="panel-label">Width</label>
                                <div className="panel-input">
                                    <div className="flex justify-between">
                                        <ImageDropDown selectedOption={imageWidthMode.label} onSelect={handleWidthSelect} />
                                        {(imageWidthMode.value === "px" || imageWidthMode.value === "%") && <input placeholder="Enter image width" type="number"
                                            style={{ width: "118px", outline: "none", borderLeft: "1px solid #7D84924D", paddingLeft: "10px" }}
                                            min={0}
                                            defaultValue={100}
                                            onChange={(e: any) => onModalChange("styles", "width", parseInt(e.target.value) + `${imageWidthMode.value}`)}></input>}
                                    </div>
                                </div>
                            </div>
                            <div className="panel-div">
                                <label className="panel-label">Height</label>
                                <div className="panel-input">
                                    <div className="flex justify-between">
                                        <ImageDropDown selectedOption={imageHeightMode.label} onSelect={handleHeightSelect} />
                                        {(imageHeightMode.value === "px" || imageHeightMode.value === "%") && <input placeholder="Enter image height" type="number"
                                            style={{ width: "118px", outline: "none", borderLeft: "1px solid #7D84924D", paddingLeft: "10px" }}
                                            min={0}
                                            defaultValue={100}
                                            onChange={(e: any) => onModalChange("styles", "height", parseInt(e.target.value) + `${imageHeightMode.value}`)}></input>}
                                    </div>
                                </div>
                            </div>
                            <Margin
                                onChange={(value: number) => onModalChange("styles", "margin", `${value}px`)}
                                label="Margin"
                                key="image"
                                onMarginChange={(value:number,postion:string)=>onModalChange("styles", `margin-${postion}`, `${value}px`)}
                                defaultValue={modalConfigs?.Image?.styles}
                                onToggleExpand={() => setIsExpandedMargin(!isExpandedMargin)}
                                isExpandMargin={isExpandedMargin}
                                isCheckedIn={props.isCheckedIn}
                            />
                        </>
                    }
                    {ErrMessage && (
                        <p
                            data-test-id="validation_error_message"
                            style={{ color: "red", textAlign: "left", marginTop: "10px" }}
                        >
                            {ErrMessage}
                        </p>
                    )}
                </div>}
            <div className="w-full">
                <div className="w-full bg-transparent">
                    {
                        body && body?.length > 0 && body.map((items: any, i: number) => {
                            const hasMargins = items[items?.type]?.styles?.['margin-top'] || items[items?.type]?.styles?.['margin-bottom'] || items[items?.type]?.styles?.['margin-right'] || items[items?.type]?.styles?.['margin-left'];

                            return (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <>
                                                <Disclosure.Button onClick={() => setEditingIndex(i)} style={{ borderRadius: "4px", height: "28px", marginTop: "10px", background: "#EFF0F4" }}
                                                    className="flex items-center p-2 w-full marginTop_seg justify-between rounded-sm text-purple-900 focus:outline-none focus-visible:ring-opacity-75">
                                                    <span style={{ fontWeight: 600, fontSize: "12px", color: "#505F7B" }}>{items?.type}</span>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <Delete style={{ cursor: "pointer" }} height="15px"
                                                            onClick={() => deleteContent(i)}
                                                        />
                                                        <div>
                                                            {open ? <Up></Up> : <Down></Down>}
                                                        </div>
                                                    </div>
                                                </Disclosure.Button>
                                                <Transition
                                                    show={open}
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <div onClick={() => setEditingIndex(i)} style={{ border: "1.5px solid #EFF0F4", borderTop: "none", padding: "0px 5px 9px", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "4px", borderBottomLeftRadius: "4px", background: "#ffffff" }}>
                                                        <Disclosure.Panel static>
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                <div className="w-full">
                                                                    <div className="w-full bg-transparent">
                                                                        <div className="panel-div flex items-center justify-between">
                                                                            <label className="panel-label">
                                                                                Content type
                                                                            </label>
                                                                            <Dropdown
                                                                                cursorStyle="pointer"
                                                                                options={data.contentType
                                                                                    ? data.contentType.map((el) => ({
                                                                                        name: el.label
                                                                                    }))
                                                                                    : []}
                                                                                selected={{ name: items?.type }}
                                                                                onChange={(option) => {
                                                                                    if (data.contentType) {
                                                                                        const item = data.contentType.find(item => item.label === option.name)
                                                                                        if (item) {
                                                                                            onModalEdit(i, items.id, "type", "type", item.label);
                                                                                        }
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {items?.type === "Text" &&
                                                                    <>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Content</label>
                                                                            <input placeholder="Enter content" type="string" className="panel-input"
                                                                                defaultValue={items[items?.type]?.content}
                                                                                onChange={(e: any) => onModalEdit(i, items.id, "config", "content", e.target.value)}></input>
                                                                        </div>
                                                                        <FontStyles
                                                                            label="Font settings"
                                                                            value={{
                                                                                placeholder: "",
                                                                                where: `${items.id}`,
                                                                                type: "",
                                                                                label: "Font Settings",
                                                                                category: "", value: { ...body[editingIndex]?.Text?.styles }
                                                                            }}
                                                                            placeholder="Customize text apperance"
                                                                            open={() => {
                                                                                setEditingIndex(i);
                                                                                setEditFontStylesContext({
                                                                                    placeholder: "",
                                                                                    where: `${items.id}`,
                                                                                    type: "",
                                                                                    label: "Font Settings",
                                                                                    category: "", value: { ...body[editingIndex]?.Text?.styles }
                                                                                })
                                                                                dispatch(onsetClrPicContext({
                                                                                    value: body[editingIndex]?.Text?.styles?.color,
                                                                                    where: 'properties.body',
                                                                                    visibility: false,
                                                                                    type: "addExpansion_newSetup"
                                                                                }))
                                                                                setFontStylesVisibility(false);
                                                                                setEditFontStylesVisibility(!editFontStylesVisibility);
                                                                            }}
                                                                        >
                                                                        </FontStyles>
                                                                        <Margin
                                                                            onChange={(value: number) => onModalEdit(i, items.id, "styles", "margin", `${value}px`)}
                                                                            label="Margin"
                                                                            key={items.id}
                                                                            editMode={true}
                                                                            defaultValue={items?.Text?.styles}
                                                                            onMarginChange={(value:number,postion:string)=>onModalEdit(editingIndex, items.id, "styles", `margin-${postion}`, `${value}px`)}
                                                                            isExpandMargin = { expandedMargins[items.id] ?? hasMargins }
                                                                            onToggleExpand={() => {
                                                                                setExpandedMargins(prev => ({
                                                                                    ...prev,
                                                                                    [items.id]: !(expandedMargins[items.id] ?? hasMargins)
                                                                                }));
                                                                            }}
                                                                            isCheckedIn={props.isCheckedIn}
                                                                        />
                                                                    </>
                                                                }
                                                                {items?.type === "Icon" &&
                                                                    <>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Icon variant</label>
                                                                            <Dropdown
                                                                                cursorStyle="pointer"
                                                                                options={data.icons
                                                                                    ? data.icons.map((el) => ({
                                                                                        name: el.label
                                                                                    }))
                                                                                    : []}
                                                                                selected={{ name: items?.Icon ? items?.Icon?.variant.charAt(0).toUpperCase() + items?.Icon?.variant.slice(1) : "Success" }}
                                                                                onChange={(option) => {
                                                                                    if (data.icons) {
                                                                                        const item = data.icons.find(item => item.label === option.name);
                                                                                        if (item) {
                                                                                            setIcons(item.label);
                                                                                            onModalEdit(i, items.id, "config", "variant", item.value);
                                                                                        }
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <Margin
                                                                            onChange={(value: number) => onModalEdit(i, items.id, "styles", "margin", `${value}px`)}
                                                                            label="Margin"
                                                                            key={items.id}
                                                                            defaultValue={items?.Icon?.styles}
                                                                            editMode={true}
                                                                            onMarginChange={(value:number,postion:string)=>onModalEdit(editingIndex, items.id, "styles", `margin-${postion}`, `${value}px`)}
                                                                            isExpandMargin={ expandedMargins[items.id] ?? hasMargins }
                                                                            onToggleExpand={() => {
                                                                                setExpandedMargins(prev => ({
                                                                                    ...prev,
                                                                                    [items.id]: !(expandedMargins[items.id] ?? hasMargins)
                                                                                }));
                                                                            }}
                                                                            isCheckedIn={props.isCheckedIn}
                                                                        />
                                                                    </>
                                                                }
                                                                {items?.type === "Input" &&
                                                                    <>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Name</label>
                                                                            <input placeholder="Enter name" type="string" className="panel-input"
                                                                                defaultValue={items?.Input?.name}
                                                                                onChange={(e: any) => onModalEdit(i, items.id, "config", "name", e.target.value)}></input>
                                                                        </div>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Label</label>
                                                                            <input placeholder="Enter label" type="string" className="panel-input"
                                                                                defaultValue={items?.Input?.label}
                                                                                onChange={(e: any) => onModalEdit(i, items.id, "config", "label", e.target.value)}></input>
                                                                        </div>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Placeholder</label>
                                                                            <input placeholder="Enter placeholder text" type="string" className="panel-input"
                                                                                defaultValue={items?.Input?.placeholder}
                                                                                onChange={(e: any) => onModalEdit(i, items.id, "config", "placeholder", e.target.value)}></input>
                                                                        </div>
                                                                        <Margin
                                                                            onChange={(value: number) => onModalEdit(i, items.id, "styles", "margin", `${value}px`)}
                                                                            label="Margin"
                                                                            defaultValue={items?.Input?.styles}
                                                                            key={items.id}
                                                                            editMode={true}
                                                                            onMarginChange={(value:number,postion:string)=>onModalEdit(editingIndex, items.id, "styles", `margin-${postion}`, `${value}px`)}
                                                                            isExpandMargin={ expandedMargins[items.id] ?? hasMargins }
                                                                            onToggleExpand={() => {
                                                                                setExpandedMargins(prev => ({
                                                                                    ...prev,
                                                                                    [items.id]: !(expandedMargins[items.id] ?? hasMargins)
                                                                                }));
                                                                            }}
                                                                            isCheckedIn={props.isCheckedIn}
                                                                        />
                                                                    </>
                                                                }
                                                                {items?.type === "Image" &&
                                                                    <>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Image url</label>
                                                                            <input placeholder="Paste image url" type="string" className="panel-input"
                                                                                defaultValue={items[items?.type]?.url}
                                                                                onChange={(e: any) => onModalEdit(i, items.id, "config", "url", e.target.value)}></input>
                                                                        </div>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Label</label>
                                                                            <input placeholder="Enter label" type="string" className="panel-input"
                                                                                defaultValue={items[items?.type]?.label}
                                                                                onChange={(e: any) => onModalEdit(i, items.id, "config", "label", e.target.value)}></input>
                                                                        </div>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Placeholder</label>
                                                                            <input placeholder="Enter placeholder text" type="string" className="panel-input"
                                                                                defaultValue={items[items?.type]?.placeholder}
                                                                                onChange={(e: any) => onModalEdit(i, items.id, "config", "placeholder", e.target.value)}></input>
                                                                        </div>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Width</label>
                                                                            <div className="panel-input">
                                                                                <div className="flex justify-between">
                                                                                    {(() => {
                                                                                        let widthMode = items?.Image?.styles?.width;
                                                                                        widthMode = widthMode ? widthMode?.replace(/\d/g, '') : "%";
                                                                                        const widthLabel = widthMode === "auto" ? "Auto" : widthMode === "min-content" ? "Min" : widthMode === "max-content" ? "Max" : widthMode;
                                                                                        return (
                                                                                            <>
                                                                                                <ImageDropDown selectedOption={widthLabel} onSelect={handleWidthSelect} value={widthMode === "%" ? !isNaN(items?.Image?.styles?.width.charAt(0)) ? items?.Image?.styles?.width.slice(0, -1) : 100 : !isNaN(items?.Image?.styles?.width.charAt(0)) ? items?.Image?.styles?.width.slice(0, -2) : 100} i={i} id={items?.id} type="width" />
                                                                                                {(widthMode === "px" || widthMode === "%") && <input placeholder="Enter image width" type="number"
                                                                                                    style={{ width: "118px", outline: "none", borderLeft: "1px solid #7D84924D", paddingLeft: "10px" }}
                                                                                                    min={0}
                                                                                                    defaultValue={widthMode === "%" ? !isNaN(items?.Image?.styles?.width.charAt(0)) ? items?.Image?.styles?.width.slice(0, -1) : 100 : !isNaN(items?.Image?.styles?.width.charAt(0)) ? items?.Image?.styles?.width.slice(0, -2) : 100}
                                                                                                    onChange={(e: any) => onModalEdit(i, items.id, "styles", "width", e.target.value + `${widthMode}`)}></input>}
                                                                                            </>
                                                                                        )
                                                                                    })()}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="panel-div">
                                                                            <label className="panel-label">Height</label>
                                                                            <div className="panel-input">
                                                                                <div className="flex justify-between">
                                                                                    {(() => {
                                                                                        let heightMode = items?.Image?.styles?.height;
                                                                                        heightMode = heightMode ? heightMode.replace(/\d/g, '') : "%";
                                                                                        const heightLabel = heightMode === "auto" ? "Auto" : heightMode === "min-content" ? "Min" : heightMode === "max-content" ? "Max" : heightMode;
                                                                                        return (
                                                                                            <>
                                                                                                <ImageDropDown selectedOption={heightLabel} onSelect={handleHeightSelect} value={heightMode === "%" ? !isNaN(items?.Image?.styles?.height?.charAt(0)) ? items?.Image?.styles?.height.slice(0, -1) : 100 : !isNaN(items?.Image?.styles?.height?.charAt(0)) ? items?.Image?.styles?.height.slice(0, -2) : 100} i={i} id={items?.id} type="height" />
                                                                                                {(heightMode === "px" || heightMode === "%") && <input placeholder="Enter image height" type="number"
                                                                                                    style={{ width: "118px", outline: "none", borderLeft: "1px solid #7D84924D", paddingLeft: "10px" }}
                                                                                                    min={0}
                                                                                                    defaultValue={heightMode === "%" ? !isNaN(items?.Image?.styles?.height?.charAt(0)) ? items?.Image?.styles?.height.slice(0, -1) : 100 : !isNaN(items?.Image?.styles?.height?.charAt(0)) ? items?.Image?.styles?.height.slice(0, -2) : 100}
                                                                                                    onChange={(e: any) => onModalEdit(i, items.id, "styles", "height", e.target.value + `${heightMode}`)}></input>}
                                                                                            </>
                                                                                        )
                                                                                    })()}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <Margin
                                                                            onChange={(value: number) => onModalEdit(i, items.id, "styles", "margin", `${value}px`)}
                                                                            label="Margin"
                                                                            defaultValue={items?.Image?.styles}
                                                                            key={items.id}
                                                                            editMode={true}
                                                                            onMarginChange={(value:number,postion:string)=>onModalEdit(editingIndex, items.id, "styles", `margin-${postion}`, `${value}px`)}
                                                                            isExpandMargin={ expandedMargins[items.id] ?? hasMargins }
                                                                            onToggleExpand={() => {
                                                                                setExpandedMargins(prev => ({
                                                                                    ...prev,
                                                                                    [items.id]: !(expandedMargins[items.id] ?? hasMargins)
                                                                                }));
                                                                            }}
                                                                            isCheckedIn={props.isCheckedIn}
                                                                        />
                                                                    </>
                                                                }
                                                            </div>
                                                        </Disclosure.Panel>
                                                    </div>
                                                </Transition>
                                            </>
                                        )}
                                    </Disclosure>
                                    {editFontStylesVisibility ?
                                        <FontStylesPopper
                                            component={component}
                                            isCheckedIn={true}
                                            close={() => {
                                                setEditFontStylesVisibility(false);
                                            }}
                                            onChange={(where: string, values: any) => handleChange(body[editingIndex].id, editingIndex, values)}
                                            fontStylesContext={{
                                                placeholder: "",
                                                where: "modalContent",
                                                type: "",
                                                label: "Font Settings",
                                                category: "", value: { ...body[editingIndex]?.Text?.styles }
                                            }}
                                            setFontStylesContext={setEditFontStylesContext}
                                            open={() => {
                                                setEditFontStylesContext({
                                                    placeholder: "",
                                                    where: `${items.id}`,
                                                    type: "",
                                                    label: "Font Settings",
                                                    category: "", value: { ...body[editingIndex]?.Text?.styles }
                                                });
                                                dispatch(onsetClrPicContext({
                                                    value: body[editingIndex]?.Text?.styles?.color,
                                                    where: "background",
                                                    visibility: true,
                                                    type: "addExpansion_newSetup"
                                                }))
                                            }}
                                        >
                                        </FontStylesPopper> : null
                                    }
                                </>
                            )
                        })
                    }
                </div>
            </div>
        </>
    )
}